import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';

const queryletsReducer = (list = [], filter = () => true, mapper = (item) => item) =>
  list.reduce((memo, item) => {
    // Filter
    if (filter(item)) {
      // Recursively process children
      const { children } = item;
      memo.push(
        mapper({
          ...item,
          ...(children && {
            children: queryletsReducer(children, filter, mapper),
          }),
        })
      );
    }
    return memo;
  }, []);

const queryletsFilter = (item) => {
  const { displayName } = item;
  switch (displayName) {
    case 'Original Patent Assignee':
      return !Auth.isFeatureEnabled(FEATURES.disablePatentSightUIChanges);
    case 'Shipment Time':
      return false;
    case 'Shipping Time':
      return true;
    default:
      return true;
  }
};

const queryletsMapper = (item) => {
  const { displayName } = item;
  const AUTHORS_INVENTORS = 'Authors/Inventors';
  switch (displayName) {
    case 'Current Patent Assignee': {
      return !Auth.isFeatureEnabled(FEATURES.disablePatentSightUIChanges)
        ? item
        : {
            ...item,
            displayName: 'Patent Assignee',
          };
    }
    case 'Authors/Inventors': {
      const shouldRenameAuthorsInventors =
        Auth.isFeatureEnabled(FEATURES.enableAuthorNameSearchImprovements) || Auth.isFeatureEnabled(FEATURES.disablePatentSightUIChanges);
      return shouldRenameAuthorsInventors
        ? {
            ...item,
            displayName: AUTHORS_INVENTORS,
          }
        : item;
    }

    case 'Names':

    // eslint-disable-next-line no-fallthrough
    case 'Authors': {
      return {
        ...item,
        displayName: AUTHORS_INVENTORS,
      };
    }
    default: {
      return item;
    }
  }
};

export default (response) =>
  response &&
  response.map((responseItem) => {
    const { tree } = responseItem;
    return {
      ...responseItem,
      ...(tree && {
        tree: queryletsReducer([tree], queryletsFilter, queryletsMapper)[0],
      }),
    };
  });
